import './index.css'

import React from 'react'
import Link from 'components/ui/link'
// Icon inlined because it’s not used anywhere else and does not fit to regular icon square size
const ICON = (
  <svg width="12" height="12">
    <path
      fill="currentcolor"
      d="M6 12c-.256 0-.512-.098-.707-.293l-5-5c-.391-.391-.391-1.023 0-1.414l5-5c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414L2.414 6l4.293 4.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293"
    />
  </svg>
)
type Props = {
  breadcrumbs: {
    content: React.ReactNode
    link: string
  }
}

const Breadcrumbs = ({ breadcrumbs }: Props): React.ReactElement<'div'> => (
  <div className="PageHeader-breadcrumbs">
    <Link className="PageHeader-breadcrumbs-link" href={breadcrumbs.link}>
      {ICON}
      {breadcrumbs.content}
    </Link>
  </div>
)

export default Breadcrumbs
